// extracted by mini-css-extract-plugin
export default {"international__regulations":"InternationalRegulations_international__regulations__-n1GQ"};